import {
  trigger,
  style,
  animate,
  transition,
  AnimationTriggerMetadata,
} from '@angular/animations';

export const animations: AnimationTriggerMetadata[] = [
  trigger('authModalFormAnimation', [
    transition(':enter', [
      style({opacity: 0}),
      animate(100)
    ]),
    transition(':leave', [
      animate(100, style({
        opacity: 0
      }))
    ])
  ])
];



// WEBPACK FOOTER //
// ./src/app/app.animations.component.ts